import React from "react";

const Summary = () => {
  return (
    <div className="h-full w-full flex flex-col md:flex-row justify-end px-10 ">
      <div className="w-1/2 p-4">
        <h2 className="font-bold text-3xl text-blue-500 whitespace-nowrap">
          Find Us Here
        </h2>
        <div className="flex p-2 items-center gap-2 pt-4 w-96">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={72}
            height={72}
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M12 20.9l4.95-4.95a7 7 0 1 0-9.9 0L12 20.9zm0 2.828l-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728zM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
              fill="rgba(243, 244, 246, var(--tw-text-opacity))"
            />
          </svg>

          <p className="text:base md:text-lg text-gray-500 dark:text-gray-100">
            Tharappel Tower, Highway Road Kidangoor, Kottayam - 686572
          </p>
        </div>
        <div
          onClick={() => {
            window.location.href = "tel:9539907670";
          }}
          className="flex p-2 items-center gap-2 pt-4 w-96 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={42}
            height={42}
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M9.366 10.682a10.556 10.556 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995c-.53.055-1.064.082-1.602.082C9.94 21 3 14.06 3 5.5c0-.538.027-1.072.082-1.602A1 1 0 0 1 4.077 3h4.462a1 1 0 0 1 .997.921A11.422 11.422 0 0 0 10.9 8.504a1 1 0 0 1-.296 1.294l-1.238.884zm-2.522-.657l1.9-1.357A13.41 13.41 0 0 1 7.647 5H5.01c-.006.166-.009.333-.009.5C5 12.956 11.044 19 18.5 19c.167 0 .334-.003.5-.01v-2.637a13.41 13.41 0 0 1-3.668-1.097l-1.357 1.9a12.442 12.442 0 0 1-1.588-.75l-.058-.033a12.556 12.556 0 0 1-4.702-4.702l-.033-.058a12.442 12.442 0 0 1-.75-1.588z"
              fill="rgba(243, 244, 246, var(--tw-text-opacity))"
            />
          </svg>

          <p className="text-xl md:text-3xl text-gray-500 dark:text-gray-100">
            9539907670
          </p>
        </div>
        <div
          onClick={() => {
            window.location.href = "mailto:chilltechcoollingsystems@gmail.com";
          }}
          className="flex p-2 items-center gap-2 pt-4 w-96 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={42}
            height={42}
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fill="rgba(243, 244, 246, var(--tw-text-opacity))"
              d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"
            />
          </svg>

          <p className="text-lg md:text-xl text-gray-500 dark:text-gray-100">
            chilltechcoollingsystems@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default Summary;
